import React,{useEffect} from 'react';
import '../Assets/Additionalcss/Paropakaricss.css'
import parologo from '../Assets/Images/plogo.png'

function Paronavbar({ openSidebar}) {

    useEffect(()=>{

       document.getElementById("Paro-username").innerHTML=localStorage.getItem('username')

        document.getElementById("Paro-role").innerHTML=localStorage.getItem('Role')
});
    return (
        <div className='parop-navbar'>
        <div className='parop-nav-icon'>
            <i className='fa fa-bars' onClick={openSidebar}></i>
        </div>

        <div className='parop-navbar-left'>
        <div className='parop-sidebar-img'>
            <img src={parologo} alt="logo"/>&nbsp;&nbsp;
           
        </div>
        </div>

        <div className='parop-navbar-right'>
           
            <a href='#'>
            <i class="fa fa-user-circle" aria-hidden="true"></i>
            </a>
            <div className='parop-right-navbar'>
            <span id="Paro-username"></span>
            (<span id="Paro-role"></span>)
            </div>
             
           

        </div>
    </div>
    );
}

export default Paronavbar;